function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit_svg__snoo-radial-gragient",
  cx: 169.75,
  cy: 92.19,
  fx: 169.75,
  fy: 92.19,
  r: 50.98,
  gradientTransform: "matrix(1 0 0 .87 0 11.64)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#feffff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#feffff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#f9fcfc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#edf3f5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#dee9ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#d8e4e8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#ccd8df"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#c8d5dd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#ccd6de"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#d8dbe2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#ede3e9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ffebef"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit_svg__snoo-radial-gragient-2",
  cx: 47.31,
  fx: 47.31,
  r: 50.98,
  xlinkHref: "#reddit_svg__snoo-radial-gragient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit_svg__snoo-radial-gragient-3",
  cx: 109.61,
  cy: 85.59,
  fx: 109.61,
  fy: 85.59,
  r: 153.78,
  gradientTransform: "matrix(1 0 0 .7 0 25.56)",
  xlinkHref: "#reddit_svg__snoo-radial-gragient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit_svg__snoo-radial-gragient-4",
  cx: -6.01,
  cy: 64.68,
  fx: -6.01,
  fy: 64.68,
  r: 12.85,
  gradientTransform: "matrix(1.07 0 0 1.55 81.08 27.26)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#ff4500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#fc4301"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#f43f07"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#e53812"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d4301f"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit_svg__snoo-radial-gragient-5",
  cx: -73.55,
  cy: 64.68,
  fx: -73.55,
  fy: 64.68,
  r: 12.85,
  gradientTransform: "matrix(-1.07 0 0 1.55 62.87 27.26)",
  xlinkHref: "#reddit_svg__snoo-radial-gragient-4"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit_svg__snoo-radial-gragient-6",
  cx: 107.93,
  cy: 166.96,
  fx: 107.93,
  fy: 166.96,
  r: 45.3,
  gradientTransform: "matrix(1 0 0 .66 0 57.4)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#172e35"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#0e1c21"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#030708"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit_svg__snoo-radial-gragient-7",
  cx: 147.88,
  cy: 32.94,
  fx: 147.88,
  fy: 32.94,
  r: 39.77,
  gradientTransform: "matrix(1 0 0 .98 0 .54)",
  xlinkHref: "#reddit_svg__snoo-radial-gragient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit_svg__snoo-radial-gragient-8",
  cx: 131.31,
  cy: 73.08,
  fx: 131.31,
  fy: 73.08,
  r: 32.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#7a9299"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#172e35"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#172e35"
})), /*#__PURE__*/React.createElement("style", null, ".reddit_svg__snoo-cls-11,.reddit_svg__snoo-cls-9{stroke-width:0;fill:#004548}"));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M108 0C48.35 0 0 48.35 0 108c0 29.82 12.09 56.82 31.63 76.37l-20.57 20.57C6.98 209.02 9.87 216 15.64 216H108c59.65 0 108-48.35 108-108S167.65 0 108 0z",
  fill: "#fff",
  strokeWidth: 0
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 169.22,
  cy: 106.98,
  r: 25.22,
  strokeWidth: 0,
  fill: "#004548"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 46.78,
  cy: 106.98,
  r: 25.22,
  fill: "#004548",
  strokeWidth: 0
});
var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 108.06,
  cy: 128.64,
  rx: 72,
  ry: 54,
  fill: "#004548",
  strokeWidth: 0
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M86.78 123.48c-.42 9.08-6.49 12.38-13.56 12.38s-12.46-4.93-12.04-14.01c.42-9.08 6.49-15.02 13.56-15.02s12.46 7.58 12.04 16.66zM129.35 123.48c.42 9.08 6.49 12.38 13.56 12.38s12.46-4.93 12.04-14.01c-.42-9.08-6.49-15.02-13.56-15.02s-12.46 7.58-12.04 16.66z",
  fill: "#fff",
  strokeWidth: 0
});
var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  className: "reddit_svg__snoo-cls-11",
  cx: 79.63,
  cy: 116.37,
  rx: 2.8,
  ry: 3.05
});
var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  className: "reddit_svg__snoo-cls-11",
  cx: 146.21,
  cy: 116.37,
  rx: 2.8,
  ry: 3.05
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M108.06 142.92c-8.76 0-17.16.43-24.92 1.22-1.33.13-2.17 1.51-1.65 2.74 4.35 10.39 14.61 17.69 26.57 17.69s22.23-7.3 26.57-17.69c.52-1.23-.33-2.61-1.65-2.74-7.77-.79-16.16-1.22-24.92-1.22z",
  fill: "#fff",
  strokeWidth: 0
});
var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 147.49,
  cy: 49.43,
  r: 17.87,
  fill: "#004548",
  strokeWidth: 0
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M107.8 76.92c-2.14 0-3.87-.89-3.87-2.27 0-16.01 13.03-29.04 29.04-29.04 2.14 0 3.87 1.73 3.87 3.87s-1.73 3.87-3.87 3.87c-11.74 0-21.29 9.55-21.29 21.29 0 1.38-1.73 2.27-3.87 2.27z",
  fill: "#004548",
  strokeWidth: 0
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "reddit_svg__snoo-cls-9",
  d: "M62.82 122.65c.39-8.56 6.08-14.16 12.69-14.16 6.26 0 11.1 6.39 11.28 14.33.17-8.88-5.13-15.99-12.05-15.99s-13.14 6.05-13.56 15.2c-.42 9.15 4.97 13.83 12.04 13.83h.52c-6.44-.16-11.3-4.79-10.91-13.2zM153.3 122.65c-.39-8.56-6.08-14.16-12.69-14.16-6.26 0-11.1 6.39-11.28 14.33-.17-8.88 5.13-15.99 12.05-15.99 7.07 0 13.14 6.05 13.56 15.2.42 9.15-4.97 13.83-12.04 13.83h-.52c6.44-.16 11.3-4.79 10.91-13.2z"
});
function SvgReddit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}
export default "data:image/svg+xml;base64,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";
export { SvgReddit as ReactComponent };